<template>
  <div class="wrapper grid-x">
    <div class="cell small-12 medium-6" :class="{'medium-order-2': imagesLeft}">
      <v-text class="text-content" :class="{'-right': imagesLeft}" :text="text"/>
    </div>
    <div class="cell small-12 medium-6" :class="{'medium-order-1': imagesLeft}">
      <div class="images">
        <div class="images-column -first">
          <div class="image" :style="{backgroundImage: `url(${images[0].url})`}"/>
          <div class="image" :style="{backgroundImage: `url(${images[1].url})`}"/>
        </div>
        <div class="images-column -second">
          <div class="image" :style="{backgroundImage: `url(${images[2].url})`}"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VText from './Text';

  export default {
    props: {
      text: Array,
      images: Array,
      imagesLeft: Boolean
    },
    components: {
      VText
    }
  }
</script>

<style lang="scss" scoped>
  @import 'foundation-sites/scss/foundation.scss';
  @import '@/assets/scss/_settings';
  .wrapper {
    margin: {
      top: vw-relative(40);
      bottom: vw-relative(40);
    }
  }
  .images {
    display: flex;
  }
  .images-column {
    &.-first {
      width: 30%;
      margin-right: 5%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
    &.-second {
      width: 65%;
    }
  }
  .image {
    width: 100%;
    padding-top: 100%;
    background-position: center;
    background-size: cover;
  }
  .text-content {
    @include breakpoint(medium) {
      padding-right: vw-relative(32);
      &.-right {
        padding-right: 0;
        padding-left: vw-relative(32);
      }
    }
  }
</style>
